module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, _vm._l((_vm.insightItems), function(item) {
    return _c('page-views-item', {
      key: item.name,
      staticClass: "metric-item",
      attrs: {
        "title": item.title,
        "description": item.description,
        "chartData": item.data,
        "stacked": item.stacked,
        "showLegend": item.showLegend,
        "type": item.type
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829ea784","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/PageViewsDashboard.vue
// module id = 3359
// module chunks = 3